import * as React from "react";
import Box from "@mui/material/Box";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarExport,
} from "@mui/x-data-grid";

const NOMBRES_MESES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const HEADER_COLORS = {
    default: {
        background: "linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)",
        color: "#1a8a9e",
    },
    precipitacion: {
        background: "linear-gradient(135deg, #e1f5fe 0%, #b3e5fc 100%)",
        color: "#01579b",
    },
    tormentas: {
        background: "linear-gradient(135deg, #fff3e0 0%, #ffcc80 100%)",
        color: "#e65100",
    },
    visibilidad: {
        background: "linear-gradient(135deg, #f3e5f5 0%, #ce93d8 100%)",
        color: "#6a1b9a",
    },
};

function CustomToolbar() {
    return (
        <GridToolbarContainer
            sx={{
                p: 1,
                borderBottom: "1px solid #e0e0e0",
                bgcolor: "#fafafa",
            }}
        >
            <GridToolbarExport
                sx={{
                    color: "#1a8a9e",
                    fontWeight: 500,
                    "&:hover": {
                        bgcolor: "#e0f7fa",
                    },
                }}
            />
        </GridToolbarContainer>
    );
}

export default function TablaDatos({
    titulosColumnas,
    datosTabla,
    titulosColumnas2,
}) {
    let colsHeaders = [];
    let rows = [];

    let columnGroupingModelRvr = null;
    if (titulosColumnas2 && titulosColumnas2.length > 0) {
        columnGroupingModelRvr = [];

        titulosColumnas.forEach((item, i) => {
            columnGroupingModelRvr.push({
                groupId: item,
                headerClassName: "tabla-header-default",
                description: "",
                children: [{ field: i === 0 ? "id" : i.toString() }],
                headerAlign: "left",
            });
        });
    }

    const columnGroupingModel = [
        {
            groupId: " ",
            description: "",
            children: [{ field: "id" }],
            headerClassName: "tabla-header-default",
            headerAlign: "center",
        },
        {
            groupId: "PRECIPITACIÓN",
            headerClassName: "tabla-header-precipitacion",
            description: "",
            children: [{ field: "1" }, { field: "2" }],
            headerAlign: "center",
        },
        {
            groupId: "TORMENTAS",
            children: [{ field: "3" }, { field: "4" }, { field: "5" }],
            headerAlign: "center",
            headerClassName: "tabla-header-tormentas",
        },
        {
            groupId: "FENOMENOS DE VISIBILIDAD",
            headerClassName: "tabla-header-visibilidad",
            children: [{ field: "6" }, { field: "7" }, { field: "8" }],
            headerAlign: "center",
        },
    ];

    let fenomenosCols = false;

    (titulosColumnas2 && titulosColumnas2.length > 0
        ? titulosColumnas2
        : titulosColumnas
    ).forEach((tituloCol, i) => {
        fenomenosCols = tituloCol === "LLUVIAS" || fenomenosCols;
        let headerClass = "tabla-header-default";

        if (["LLUVIAS", "LLOVIZNAS"].includes(tituloCol)) {
            headerClass = "tabla-header-precipitacion";
        }
        if (["CON LLUVIAS", "CON GRANIZO", "SIN LLUVIAS"].includes(tituloCol)) {
            headerClass = "tabla-header-tormentas";
        }
        if (["NIEBLA", "NEBLINA", "HUMO"].includes(tituloCol)) {
            headerClass = "tabla-header-visibilidad";
        }

        colsHeaders.push({
            field: i === 0 ? "id" : i.toString(),
            headerName: tituloCol,
            minWidth: 110,
            maxWidth: "100%",
            flex: 1,
            headerClassName: headerClass,
            headerAlign: "center",
            align: i === 0 ? "left" : "center",
        });
    });

    const primeraColumnaEsMes = titulosColumnas[0]?.toUpperCase() === "MES";

    datosTabla.forEach((fila, i) => {
        let row = {};
        fila.forEach((val, col) => {
            if (col === 0) {
                const numVal = parseInt(val, 10);
                if (primeraColumnaEsMes && !isNaN(numVal) && numVal >= 1 && numVal <= 12) {
                    row["id"] = NOMBRES_MESES[numVal - 1];
                } else {
                    row["id"] = val;
                }
            } else {
                row[col.toString()] = val;
            }
        });
        rows.push(row);
    });

    let colGroupingModel = [];
    if (fenomenosCols) colGroupingModel = columnGroupingModel;
    else if (columnGroupingModelRvr) colGroupingModel = columnGroupingModelRvr;

    return (
        <Box
            sx={{
                width: "100%",
                position: "relative",
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid #e0e0e0",
                height: { xs: 400, sm: 500, md: 600 },
                "& .tabla-header-default": {
                    ...HEADER_COLORS.default,
                    fontWeight: 600,
                    fontSize: "0.8rem",
                },
                "& .tabla-header-precipitacion": {
                    ...HEADER_COLORS.precipitacion,
                    fontWeight: 600,
                    fontSize: "0.8rem",
                },
                "& .tabla-header-tormentas": {
                    ...HEADER_COLORS.tormentas,
                    fontWeight: 600,
                    fontSize: "0.8rem",
                },
                "& .tabla-header-visibilidad": {
                    ...HEADER_COLORS.visibilidad,
                    fontWeight: 600,
                    fontSize: "0.8rem",
                },
                "& .MuiDataGrid-root": {
                    border: "none",
                    fontSize: "0.85rem",
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f0f0f0",
                    py: 1.5,
                    "&:focus": {
                        outline: "none",
                    },
                    "&:focus-within": {
                        outline: "none",
                    },
                },
                "& .MuiDataGrid-row": {
                    "&:nth-of-type(even)": {
                        bgcolor: "#fafafa",
                    },
                    "&:hover": {
                        bgcolor: "#e0f7fa",
                    },
                    "&.Mui-selected": {
                        bgcolor: "#e0f7fa",
                        "&:hover": {
                            bgcolor: "#b2ebf2",
                        },
                    },
                },
                "& .MuiDataGrid-columnHeaders": {
                    borderBottom: "2px solid #3baec7",
                },
                "& .MuiDataGrid-columnHeader": {
                    "&:focus": {
                        outline: "none",
                    },
                    "&:focus-within": {
                        outline: "none",
                    },
                },
                "& .MuiDataGrid-columnSeparator": {
                    color: "rgba(0, 0, 0, 0.1)",
                },
                "& .MuiDataGrid-virtualScroller": {
                    bgcolor: "white",
                    overflowY: "auto !important",
                },
                "& .MuiDataGrid-footerContainer": {
                    borderTop: "1px solid #e0e0e0",
                    bgcolor: "#fafafa",
                },
            }}
        >
            <DataGrid
                rows={rows}
                columns={colsHeaders}
                hideFooter={true}
                disableColumnMenu={true}
                disableRowSelectionOnClick
                columnGroupingModel={colGroupingModel}
                slots={{
                    toolbar: CustomToolbar,
                }}
                getRowId={(row) => row.id}
                localeText={{
                    toolbarExport: "Exportar",
                    toolbarExportCSV: "Descargar como CSV",
                    toolbarExportPrint: "Imprimir",
                }}
            />
        </Box>
    );
}
